export interface ClientConfig {
  gameServerUrl: string;
  /** API de contas (sem barra no fim). */
  apiUrl: string;
  /** Site (criar conta, perfil), sem barra no fim. */
  siteUrl: string;
}

type Env = Readonly<Record<string, string | undefined>>;

/**
 * Endereços do servidor de partidas, da API e do site, vindos de variáveis VITE_* do build. Em
 * desenvolvimento, `?servidor=ws://…` troca o servidor de partidas (e2e com relógio acelerado).
 */
export function readClientConfig(env: Env, search = ""): ClientConfig {
  const override = env["DEV"] ? new URLSearchParams(search).get("servidor") : null;
  return {
    gameServerUrl: (override && /^wss?:\/\/localhost:\d+$/.test(override) ? override : "") || env["VITE_GAME_SERVER_URL"] || "ws://localhost:2567",
    apiUrl: (env["VITE_API_URL"] || "http://localhost:8787").replace(/\/+$/, ""),
    siteUrl: (env["VITE_SITE_URL"] || "http://localhost:5174").replace(/\/+$/, ""),
  };
}
